export default __webpack_public_path__ + "static/media/ESSS30BZIR45.adf11da8.mp4";